import React, { useEffect, useState } from "react";
import "./ViewUserForm.css";

const ViewUserForm = ({ selectedUser, transactionHistory, onClose }) => {
  const [voucherHistory, setVoucherHistory] = useState([]);

  useEffect(() => {
    if (selectedUser) {
      fetch(`/api/user-voucher-history/${selectedUser.user_id}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setVoucherHistory(data.history);
          }
        })
        .catch((error) => console.error("Error fetching voucher history:", error));
    }
  }, [selectedUser]);

  if (!selectedUser) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h3>User Details</h3>
        <p><strong>First Name:</strong> {selectedUser.first_name}</p>
        <p><strong>Last Name:</strong> {selectedUser.last_name}</p>
        <p><strong>Email:</strong> {selectedUser.email}</p>
        <p><strong>Phone:</strong> {selectedUser.phone}</p>
        <p><strong>Membership:</strong> {selectedUser.membership_name}</p>

        <h4>Transaction History</h4>
        {transactionHistory.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {transactionHistory.map((transaction, index) => (
                <tr key={index}>
                  <td>{transaction.date}</td>
                  <td>${transaction.amount}</td>
                  <td>{transaction.payment_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No transaction history available.</p>
        )}

        <h4>Voucher History</h4>
        {voucherHistory.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Issued</th>
                <th>Redeemed</th>
              </tr>
            </thead>
            <tbody>
              {voucherHistory.map((voucher, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={voucher.voucher_image  ? `https://wwww.bleusea.com${voucher.voucher_image}` : "/fallback-image.jpg"}
                      alt="Voucher"
                      className="voucher-image"
                      onError={(e) => { e.target.src = "/images/placeholder.jpg"; }}
                    />
                  </td>
                  <td>{voucher.description}</td>
                  <td>{new Date(voucher.issue_date).toLocaleDateString()}</td>
                  <td>{voucher.redeemed ? new Date(voucher.redeemed_date).toLocaleDateString() : "Not Redeemed"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No voucher history available.</p>
        )}
      </div>
    </div>
  );
};

export default ViewUserForm;
